import app, { Component } from 'apprun';
import { isValidElement } from '../utils';
import moment from 'moment';
export default class CommonPropertyComponent extends Component {
  state = { };

  view = (state) => {
    if (!state.item) {return;}
    return (
      <form id="frm-common-props-date-edit" class="form-horizontal" style={{ width: '450px' }} autocomplete="off">
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          <div class="col-sm-12">
            <input
              $pikaday
              id="inpText"
              size="62"
              class="form-control"
              value={state.newVal}
              oninput={(e) => {
                state.newVal = e.target.value;
              }}
            />
          </div>
        </div>
        <div class="row">
          <div id="inpTextErrMsg" class="text-danger col-sm-12"></div>
        </div>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    refresh: (state, newState) => {
      return {
        ...state,
        ...newState,
        newVal: newState.item.value ? moment(newState.item.value).format('DD-MMM-YYYY') : null,
        picker: null,
      };
    },

    save: async (state) => {
      state.newVal = (document.getElementById('inpText') as HTMLInputElement).value;
      if (!state.newVal) {return;}
      if (isValidElement('inpText', state.item.validation)) {
        await state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
